import { render, staticRenderFns } from "./EditItemModel.vue?vue&type=template&id=8e2ac9fa"
import script from "./EditItemModel.vue?vue&type=script&lang=js"
export * from "./EditItemModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports